<template lang="pug">
.member-ticket-money(@click="$emit('clicked')")
  member-icon(:grade="grade")
  .price {{$t(`grade.${grade}`)}}价 ￥{{price}}
</template>
<script>
import MemberIcon from '@/components/wedgits/MemberIcon'
export default {
  name: 'MemberTicketMoney',
  components: { MemberIcon },
  props: {
    grade: {},
    price: {},
  },
  data() {
    return {}
  },
  computed: {},
  methods: {},
  mounted() {},
}
</script>

<style scoped lang="sass">
@import "src/styles/common.sass"
.member-ticket-money
  height: pxToRem(60)
  border-radius: pxToRem(30)
  line-height: pxToRem(60)
  background: white
  padding: 0 pxToRem(24)
  +flex-center
  flex-direction: row
  .price
    color: #1664FF
    font-size: pxToRem(30)
</style>
